import { FeatureFlag } from '../FeatureFlag';

export const enableNewsListDebugging = new FeatureFlag({
    key: 'enable-news-list-debugging',
    defaultValue: false,
});
